// import { User } from 'iconsax-react';
import services from '../../../_services/_fetch';
export function seek() {
  var args = {
    IdAduana: sessionStorage.getItem('aduanainfo')
  };
  
  const ENDPOINT = '/InformacionAduana';
  return new Promise((done, reject) => {
    services(args, ENDPOINT)
      .then((result: any) => {
        if (!result.Error_fectch) {
          done(result);
        } else {
          reject(result.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
